// extracted by mini-css-extract-plugin
export default {"layout":"\"../../../../../styles/variables/layout.module.css\"","breakpoint-s":"600px","breakpoint-xl":"1280px","list":"Start_list__nZQax"};